// Add to Cart + quantity picker for product cards (PLP grids, search results).
// Loaded once per page (see collection-product-grid.liquid, gift-collection-product-grid.liquid,
// section-search.liquid) and guarded below since a page can include more than one of those sections.
// Reacts to variant changes fired by component-card-size-selector.js so the button shows the
// right state (Add to Cart vs. qty stepper) for whichever size is currently selected.
(function () {
  if (window.__cardAtcInit) return;
  window.__cardAtcInit = true;

  const SELECTORS = {
    form: 'form[id^="add-to-cart-"][action="/cart/add"]',
    variantInput: 'input.product-variant-id[name="id"]',
    qtyInput: 'input[name="quantity"]',
    addBtn: ".js-go-cart-add-to-cart",
    qtyCtrl: ".ae--qty-control",
    qtyBtn: "[data-quantity-action]",
    cartCount: ".js-go-cart-counter",
  };

  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  document.addEventListener(
    "click",
    function (e) {
      const interactive = e.target.closest(
        `${SELECTORS.addBtn}, ${SELECTORS.qtyCtrl}, ${SELECTORS.qtyBtn}`,
      );
      if (!interactive) return;
      const linkWrapper = interactive.closest("a[href]");
      if (!linkWrapper) return;
      e.preventDefault();
    },
    true,
  );

  async function fetchCart() {
    const res = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    return res.json();
  }

  async function addToCart(variantId, quantity) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: Number(quantity),
      }),
    });
    if (!res.ok) throw new Error("add failed");
    return res.json();
  }

  async function setVariantQty(variantId, quantity) {
    const fd = new FormData();
    fd.append(`updates[${variantId}]`, String(quantity));
    const res = await fetch("/cart/update.js", {
      method: "POST",
      body: fd,
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error("update failed");
    return res.json();
  }

  function getTotalQtyForVariant(cart, variantId) {
    let total = 0;
    for (const item of cart.items || []) {
      if (String(item.id) === String(variantId)) total += item.quantity;
    }
    return total;
  }

  function updateHeaderCartCount(cart) {
    const total = cart.item_count || 0;
    document.querySelectorAll(SELECTORS.cartCount).forEach((el) => {
      el.textContent = total;
    });
  }

  function getFormVariantId(form) {
    return form.querySelector(SELECTORS.variantInput)?.value;
  }

  function getFormMinQty(form) {
    const minAttr = form.querySelector(SELECTORS.qtyInput)?.getAttribute("min");
    const n = Number(minAttr);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function getFormQtyStep(form) {
    const stepAttr = form.querySelector(SELECTORS.qtyInput)?.dataset
      .qtyIncrement;
    const n = Number(stepAttr);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function getFormQtyMax(form) {
    const maxAttr = form.querySelector(SELECTORS.qtyInput)?.dataset.qtyMax;
    if (maxAttr === undefined || maxAttr === "") return Infinity;
    const n = Number(maxAttr);
    return Number.isFinite(n) && n >= 0 ? n : Infinity;
  }

  function ensureQtyControl(form) {
    let ctrl = form.querySelector(SELECTORS.qtyCtrl);
    if (ctrl) return ctrl;

    ctrl = document.createElement("div");
    ctrl.className = "ae--qty-control";
    ctrl.setAttribute("role", "group");
    ctrl.setAttribute("aria-label", "Quantity selector");
    ctrl.innerHTML = `
      <button type="button" class="ae--qty-btn" data-quantity-action="dec" aria-label="Decrease quantity">
        <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 6H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
        </svg>
      </button>
      <span class="ae--qty-val" aria-live="polite">1</span>
      <button type="button" class="ae--qty-btn" data-quantity-action="inc" aria-label="Increase quantity">
        <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 2V10M2 6H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
        </svg>
      </button>
    `;

    const addBtn = form.querySelector(SELECTORS.addBtn);
    if (addBtn && addBtn.parentNode)
      addBtn.parentNode.insertBefore(ctrl, addBtn);
    else form.appendChild(ctrl);

    return ctrl;
  }

  function showQtyControl(form, qty) {
    const buildBtn = form.querySelector('[data-card-build]');
    if (buildBtn) buildBtn.style.setProperty('display', 'none', 'important');
    const addBtn = form.querySelector(SELECTORS.addBtn);
    if (addBtn) addBtn.style.display = "none";
    const ctrl = ensureQtyControl(form);
    ctrl.querySelector(".ae--qty-val").textContent = String(qty);
    ctrl.style.display = "flex";
    ctrl.dataset.variantId = getFormVariantId(form) || "";

    const incBtn = ctrl.querySelector('[data-quantity-action="inc"]');
    if (incBtn) incBtn.disabled = qty >= getFormQtyMax(form);
  }

  function hideQtyControl(form) {
    const buildBtn = form.querySelector('[data-card-build]');
    if (buildBtn) buildBtn.style.removeProperty('display');
    const addBtn = form.querySelector(SELECTORS.addBtn);
    if (addBtn) addBtn.style.display = "";
    const ctrl = form.querySelector(SELECTORS.qtyCtrl);
    if (ctrl) ctrl.style.display = "none";
  }

  async function reflectCartOnPage() {
    const cart = await fetchCart();
    const forms = $$(SELECTORS.form);
    const byVariant = new Map();
    for (const f of forms) {
      if (f.dataset.qtyPending === "true") continue;
      const vid = getFormVariantId(f);
      if (!vid) continue;
      if (!byVariant.has(vid)) byVariant.set(vid, []);
      byVariant.get(vid).push(f);
    }
    for (const [vid, formList] of byVariant.entries()) {
      const qty = getTotalQtyForVariant(cart, vid);
      if (qty > 0) formList.forEach((f) => showQtyControl(f, qty));
      else formList.forEach((f) => hideQtyControl(f));
    }
    updateHeaderCartCount(cart);
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
  }

  const pendingQty = new WeakMap();
  // Tracks the in-flight /cart/add.js promise per form (see handleAddToCart) so a
  // qty +/- click that lands while the initial add hasn't reached the server yet
  // waits for it instead of updating a line that doesn't exist there yet.
  const pendingAdd = new WeakMap();
  const QTY_DEBOUNCE_MS = 400;

  function scheduleQtyUpdate(form, variantId, targetQty) {
    let state = pendingQty.get(form);
    if (!state) {
      state = { timer: null, seq: 0 };
      pendingQty.set(form, state);
    }
    if (state.timer) clearTimeout(state.timer);
    const mySeq = ++state.seq;
    form.dataset.qtyPending = "true";

    state.timer = setTimeout(async () => {
      try {
        const addInFlight = pendingAdd.get(form);
        if (addInFlight) await addInFlight.catch(() => {});
        if (state.seq !== mySeq) return; // superseded while we were waiting on the add

        const cart = await setVariantQty(variantId, targetQty);
        if (state.seq !== mySeq) return; // a newer click already superseded this request

        updateHeaderCartCount(cart);
        const actualQty = getTotalQtyForVariant(cart, variantId);
        if (actualQty !== targetQty) {
          // Server disagreed with the optimistic value (e.g. clamped by stock) — correct it.
          if (actualQty > 0) showQtyControl(form, actualQty);
          else hideQtyControl(form);
        }
        document.dispatchEvent(
          new CustomEvent("cart:updated", { detail: cart }),
        );
      } catch (err) {
        console.error(err);
        if (state.seq !== mySeq) return;
        await reflectCartOnPage(); // roll back to server truth on failure
      } finally {
        if (state.seq === mySeq) form.dataset.qtyPending = "false";
      }
    }, QTY_DEBOUNCE_MS);
  }

  async function handleAddToCart(form) {
    if (form.dataset.atcBusy === "true") return;

    const qtyState = pendingQty.get(form);
    if (qtyState?.timer) {
      clearTimeout(qtyState.timer);
      form.dataset.qtyPending = "false";
    }

    const variantId = getFormVariantId(form);
    if (!variantId) return;
    const initialQty = Number(
      form.querySelector(SELECTORS.qtyInput)?.value || 1,
    );

    form.dataset.atcBusy = "true";
    // Optimistic: swap straight to the qty stepper, interactive right away — it
    // does not wait on /cart/add.js, and a +/- click that lands during this window
    // just waits for it in the background (see pendingAdd in scheduleQtyUpdate).
    showQtyControl(form, initialQty);

    const addPromise = addToCart(variantId, initialQty);
    pendingAdd.set(form, addPromise);

    try {
      const item = await addPromise;
      // Reconcile in case Shopify merged this into an existing line that already had
      // items in it, or clamped the quantity — otherwise the optimistic value stands.
      // Skip if a qty +/- click has since taken over this form's displayed value.
      if (
        form.dataset.qtyPending !== "true" &&
        item &&
        typeof item.quantity === "number" &&
        item.quantity !== initialQty
      ) {
        if (item.quantity > 0) showQtyControl(form, item.quantity);
        else hideQtyControl(form);
      }
    } catch (err) {
      console.error(err);
      if (form.dataset.qtyPending !== "true") hideQtyControl(form); // roll back to "Add to Cart" on failure
    } finally {
      form.dataset.atcBusy = "false";
      pendingAdd.delete(form);
    }

    // Background sync (header count, other forms) — doesn't gate interactivity.
    reflectCartOnPage().catch((err) => console.error(err));
  }

  document.addEventListener("submit", async (e) => {
    const form = e.target.closest(SELECTORS.form);
    if (!form) return;
    const addBtn = form.querySelector(SELECTORS.addBtn);
    if (!addBtn) return;
    e.preventDefault();
    await handleAddToCart(form);
  });

  document.addEventListener(
    "click",
    async (e) => {
      const addBtn = e.target.closest(SELECTORS.addBtn);
      if (!addBtn) return;
      const form = addBtn.closest(SELECTORS.form);
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      await handleAddToCart(form);
    },
    true,
  );

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(SELECTORS.qtyBtn);
      if (!btn) return;

      const form = btn.closest(SELECTORS.form);
      const ctrl = btn.closest(SELECTORS.qtyCtrl);
      if (!form || !ctrl) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const variantId = getFormVariantId(form);
      if (!variantId) return;

      const valEl = ctrl.querySelector(".ae--qty-val");
      const current = Number(valEl.textContent || "0");
      const action = btn.getAttribute("data-quantity-action");
      const minQty = getFormMinQty(form);
      const step = getFormQtyStep(form);
      const maxQty = getFormQtyMax(form);

      let next = current;
      if (action === "inc") next = Math.min(current + step, maxQty);
      if (action === "dec") next = Math.max(0, current - step);

      if (current === 0 && next > 0 && next < minQty) next = minQty;
      if (next === current) return;

      if (next > 0) showQtyControl(form, next);
      else hideQtyControl(form);

      scheduleQtyUpdate(form, variantId, next);
    },
    true,
  );

  document.addEventListener("change", (e) => {
    if (!e.target.matches(SELECTORS.variantInput)) return;
    const form = e.target.closest(SELECTORS.form);
    if (form) hideQtyControl(form);
    reflectCartOnPage().catch((err) => console.error(err));
  });

  // Re-sync when the grid loads more cards (infinite scroll / AJAX pagination)
  const mo = new MutationObserver((muts) => {
    if (
      muts.some((m) =>
        Array.from(m.addedNodes).some(
          (n) => n.nodeType === 1 && n.matches?.(SELECTORS.form),
        ),
      )
    ) {
      reflectCartOnPage();
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", reflectCartOnPage);
  } else {
    reflectCartOnPage();
  }
})();
